<div class="modal-header">
    <div class="d-flex gap-5">
        <span header-icon class="svg-icon svg-icon-2x menu-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.444 5.489c-2.033-.407-2.91-1.387-3.317-3.37a.25.25 0 0 0-.241-.189.25.25 0 0 0-.241.192c-.407 2.033-1.335 2.96-3.317 3.367a.254.254 0 0 0 0 .508c2.033.407 2.906 1.366 3.313 3.349a.25.25 0 0 0 .245.21.25.25 0 0 0 .243-.197c.406-2.034 1.333-2.955 3.315-3.362a.254.254 0 1 0 0-.508Z"
                    fill="#6200b3" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M21.223 5.24a3.057 3.057 0 0 0-4.323 0L6.87 15.267a5.419 5.419 0 0 0-1.295 2.08l-1.12 3.282a1.087 1.087 0 0 0 1.378 1.38L9.1 20.896a5.42 5.42 0 0 0 2.086-1.299L21.223 9.562a3.057 3.057 0 0 0 0-4.323Zm-2.134 4.334 1.073-1.073A1.557 1.557 0 1 0 17.961 6.3l-1.073 1.073 2.201 2.201Zm-1.06 1.06-2.202-2.2-6.633 6.632a6.214 6.214 0 0 1 2.2 2.204l6.635-6.635Zm-7.743 7.744a4.71 4.71 0 0 0-2.199-2.204l-.156.155a3.918 3.918 0 0 0-.937 1.505l-.53 1.55c.28.113.501.337.61.618l1.543-.525a3.922 3.922 0 0 0 1.509-.94l.16-.16Z"
                    fill="#6200b3" />
                <path
                    d="M3.97 8.141c.17.858.67 1.271 1.527 1.528a.187.187 0 0 1 0 .374c-.857.171-1.27.67-1.528 1.528a.187.187 0 0 1-.373 0c-.172-.858-.671-1.27-1.528-1.528a.187.187 0 1 1 0-.374c.857-.171 1.27-.67 1.527-1.528a.187.187 0 0 1 .374 0Z"
                    fill="#6200b3" />
            </svg>
        </span>
        <h5 class="text-info mt-2 mb-0" translate> ia.titulo </h5>
    </div>
</div>

<div class="modal-body">


    <div *ngIf="isImage; else textObsTemplate" class="text-sm text-zinc-900" translate>
        <div class="card card-custom">
            <div class="card-header">
                <div class="card-title">
                    <span class="card-icon">
                        <span class="svg-icon svg-icon-info svg-icon-2x"><svg xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px"
                                viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24" />
                                    <path
                                        d="M21.9999843,15.009808 L22.0249378,15 L22.0249378,19.5857864 C22.0249378,20.1380712 21.5772226,20.5857864 21.0249378,20.5857864 C20.7597213,20.5857864 20.5053674,20.4804296 20.317831,20.2928932 L18.0249378,18 L5,18 C3.34314575,18 2,16.6568542 2,15 L2,6 C2,4.34314575 3.34314575,3 5,3 L19,3 C20.6568542,3 22,4.34314575 22,6 L22,15 C22,15.0032706 21.9999948,15.0065399 21.9999843,15.009808 Z M6.16794971,10.5547002 C7.67758127,12.8191475 9.64566871,14 12,14 C14.3543313,14 16.3224187,12.8191475 17.8320503,10.5547002 C18.1384028,10.0951715 18.0142289,9.47430216 17.5547002,9.16794971 C17.0951715,8.86159725 16.4743022,8.98577112 16.1679497,9.4452998 C15.0109146,11.1808525 13.6456687,12 12,12 C10.3543313,12 8.9890854,11.1808525 7.83205029,9.4452998 C7.52569784,8.98577112 6.90482849,8.86159725 6.4452998,9.16794971 C5.98577112,9.47430216 5.86159725,10.0951715 6.16794971,10.5547002 Z"
                                        fill="#000000" />
                                </g>
                            </svg>
                        </span>
                    </span>
                    <h5 class="card-label text-info flex-column" translate>
                        ia.observacao
                        <small translate> ia.ia-pode-cometer-erros-imagem </small>
                    </h5>
                </div>
            </div>
        </div>
    </div>
    <ng-template #textObsTemplate>
        <div class="card card-custom">
            <div class="card-header">
                <div class="card-title">
                    <span class="card-icon">
                        <span class="svg-icon svg-icon-info svg-icon-2x"><svg xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px"
                                viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24" />
                                    <path
                                        d="M21.9999843,15.009808 L22.0249378,15 L22.0249378,19.5857864 C22.0249378,20.1380712 21.5772226,20.5857864 21.0249378,20.5857864 C20.7597213,20.5857864 20.5053674,20.4804296 20.317831,20.2928932 L18.0249378,18 L5,18 C3.34314575,18 2,16.6568542 2,15 L2,6 C2,4.34314575 3.34314575,3 5,3 L19,3 C20.6568542,3 22,4.34314575 22,6 L22,15 C22,15.0032706 21.9999948,15.0065399 21.9999843,15.009808 Z M6.16794971,10.5547002 C7.67758127,12.8191475 9.64566871,14 12,14 C14.3543313,14 16.3224187,12.8191475 17.8320503,10.5547002 C18.1384028,10.0951715 18.0142289,9.47430216 17.5547002,9.16794971 C17.0951715,8.86159725 16.4743022,8.98577112 16.1679497,9.4452998 C15.0109146,11.1808525 13.6456687,12 12,12 C10.3543313,12 8.9890854,11.1808525 7.83205029,9.4452998 C7.52569784,8.98577112 6.90482849,8.86159725 6.4452998,9.16794971 C5.98577112,9.47430216 5.86159725,10.0951715 6.16794971,10.5547002 Z"
                                        fill="#000000" />
                                </g>
                            </svg>
                        </span>
                    </span>
                    <h5 class="card-label text-info flex-column" translate>
                        ia.observacao
                        <small translate> ia.ia-pode-cometer-erros-texto</small>
                    </h5>
                </div>
            </div>
        </div>
    </ng-template>

    <div class="timeline timeline-3 my-5">
        <div class="timeline-items">

            <div class="timeline-item">
                <div class="timeline-media">
                    <span class="svg-icon svg-icon-primary svg-icon-2x">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                            version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <polygon points="0 0 24 0 24 24 0 24" />
                                <path
                                    d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z"
                                    fill="#000000" fill-rule="nonzero" opacity="0.3" />
                                <path
                                    d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z"
                                    fill="#000000" fill-rule="nonzero" />
                            </g>
                        </svg>
                    </span>
                </div>
                <div class="timeline-content">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <div class="mr-2">
                            <span class="text-dark-75 font-weight-bolder" translate> ia.seu-texto </span>
                            <span class="text-muted ml-2" translate> ia.escolha-a-acao-desejada </span>
                        </div>
                    </div>
                    <div class="p-0">
                        <div class="p-4" style="max-height: 180px; overflow: auto;">
                            <img *ngIf="isImage; else textTemplate" class="w-100" [src]="data.url" />
                            <ng-template #textTemplate>
                                <div [innerHTML]="data.text | safe : 'html'"></div>
                            </ng-template>
                        </div>
                        <div class="d-flex justify-content-end mt-3">
                            <div *ngIf="{ value: loading$ | async } as loading" class="d-flex gap-2">
                                <ng-container *ngIf="isImage; else textOptionsTemplate">
                                    <button (click)="onMagicText(magicTextTypeEnum.Transcript)"
                                        [disabled]="!!loading.value" class="btn btn-light-info btn-sm px-2 uppercase">
                                        <span class="whitespace-nowrap" translate>ia.tipos.transcrever</span>
                                    </button>
                                </ng-container>
                                <ng-template #textOptionsTemplate>
                                    <button (click)="onMagicText(magicTextTypeEnum.Rewrite)"
                                        [disabled]="!!loading.value" class="btn btn-light-info btn-sm px-2 uppercase">
                                        <span class="whitespace-nowrap" translate>ia.tipos.reescrever</span>
                                    </button>
                                    <button (click)="onMagicText(magicTextTypeEnum.Shorten)"
                                        [disabled]="!!loading.value" class="btn btn-light-info btn-sm px-2 uppercase">
                                        <span class="whitespace-nowrap" translate>ia.tipos.encurtar</span>
                                    </button>
                                    <button (click)="onMagicText(magicTextTypeEnum.Revise)" [disabled]="!!loading.value"
                                        class="btn btn-light-info btn-sm px-2 uppercase">
                                        <span class="whitespace-nowrap" translate>ia.tipos.corrigir-ortografia</span>
                                    </button>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="timeline-item">
                <div class="timeline-media">
                    <span class="svg-icon svg-icon-info svg-icon-2x">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                            version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <rect x="0" y="0" width="24" height="24"></rect>
                                <path
                                    d="M11,20 L11,17 C11,16.4477153 11.4477153,16 12,16 C12.5522847,16 13,16.4477153 13,17 L13,20 L15.5,20 C15.7761424,20 16,20.2238576 16,20.5 C16,20.7761424 15.7761424,21 15.5,21 L8.5,21 C8.22385763,21 8,20.7761424 8,20.5 C8,20.2238576 8.22385763,20 8.5,20 L11,20 Z"
                                    fill="#000000" opacity="0.3"></path>
                                <path
                                    d="M3,5 L21,5 C21.5522847,5 22,5.44771525 22,6 L22,16 C22,16.5522847 21.5522847,17 21,17 L3,17 C2.44771525,17 2,16.5522847 2,16 L2,6 C2,5.44771525 2.44771525,5 3,5 Z M4.5,8 C4.22385763,8 4,8.22385763 4,8.5 C4,8.77614237 4.22385763,9 4.5,9 L13.5,9 C13.7761424,9 14,8.77614237 14,8.5 C14,8.22385763 13.7761424,8 13.5,8 L4.5,8 Z M4.5,10 C4.22385763,10 4,10.2238576 4,10.5 C4,10.7761424 4.22385763,11 4.5,11 L7.5,11 C7.77614237,11 8,10.7761424 8,10.5 C8,10.2238576 7.77614237,10 7.5,10 L4.5,10 Z"
                                    fill="#000000"></path>
                            </g>
                        </svg>
                    </span>
                </div>
                <div class="timeline-content">
                    <div *ngIf="{ value: activeResultData$ | async } as activeResultData">
                        <div class="d-flex align-items-center justify-content-between mb-3">
                            <div class="mr-2">
                                <span class="text-info font-weight-bold" translate> ia.resposta-ia </span>
                                <span class="text-muted ml-2">{{ activeResultData.value?.type_legend | translate
                                    }}</span>
                            </div>
                            <div class="d-flex align-items-center" *ngIf="!!activeResultData.value">
                                <button (click)="onPrior()" type="button" class="btn btn-icon btn-xs btn-clean">
                                    <i class="flaticon2-back"></i>
                                </button>
                                <span class="font-weight-bold mx-2">{{ activeResultData.value.order }}/{{ total
                                    }}</span>
                                <button (click)="onNext()" type="button" class="btn btn-icon btn-xs btn-clean">
                                    <i class="flaticon2-next"></i>
                                </button>
                            </div>
                        </div>
                        <div class="p-0">
                            <ng-container *ngIf="!!activeResultData.value; else emptyTemplate">
                                <gpe-editor-conteudo [formControl]="textEditorCtrl" [full]="true" [label]="null"
                                    [urlFileSave]="resourceEditor" [paramsUrlFileSave]="paramsResource"
                                    [heightDefault]="180"></gpe-editor-conteudo>
                            </ng-container>
                            <ng-template #emptyTemplate>
                                <ng-container *ngIf="loading$ | async; else jumbotron">
                                    <div class="d-flex justify-content-center align-items-center"
                                        style="min-height: 180px;">
                                        <div class="spinner spinner-track spinner-primary spinner-lg"></div>
                                    </div>
                                </ng-container>
                                <ng-template #jumbotron>
                                    <div class="d-flex justify-content-center align-items-center p-5 text-muted"
                                        style="min-height: 180px;" translate>
                                        ia.escolha-a-acao-desejada
                                    </div>
                                </ng-template>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>















</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger px-2 font-semibold uppercase text-white" (click)="onClose()"
        [disabled]="loading$ | async" translate>
        geral.cancelar
    </button>

    <button type="button" (click)="onConfirm()" [disabled]="loading$ | async"
        class="btn btn-success px-2 font-semibold uppercase text-white" translate>
        geral.salvar
    </button>
</div>